import { useNavigate } from "react-router-dom";
import { Briefcase, FileText, FolderKanban, Kanban, Plus, Receipt, Route, ShoppingBag, Users } from "lucide-react";
import { Menu, MenuItem } from "./bits";

// The one place to start something new — replaces permanent quick-action toolbars.
const ITEMS = [
  ["Deal", "/deals?new=1", Route], ["Lead", "/deals/pipeline?new=1", Kanban], ["Customer", "/customers?new=1", Users], ["Quote", "/deals/quotes?new=1", FileText],
  ["Job", "/jobs?new=1", Briefcase], ["Project", "/jobs/projects?new=1", FolderKanban], ["Invoice", "/money/invoices?new=1", Receipt], ["Purchase order", "/supply/purchase-orders?new=1", ShoppingBag],
];

export default function CreateMenu({ compact }) {
  const nav = useNavigate();
  return (
    <Menu testid="global-create" chevron={false} className={`btn-amber font-semibold ${compact ? "!h-10 !w-10 !p-0" : "!py-1.5 !pl-2.5 !pr-3 text-[12.5px]"}`} trigger={<><Plus size={14} strokeWidth={2.5} />{!compact && <span>Create</span>}</>}>
      <div className="eyebrow px-2.5 pb-1 pt-1.5 !text-[10px]">Create new</div>
      {ITEMS.map(([l, to, Icon]) => <MenuItem key={l} icon={Icon} onClick={() => nav(to)} testid={`create-${l.toLowerCase().replace(" ", "-")}`}>{l}</MenuItem>)}
    </Menu>
  );
}
